import {GetStaticPaths, GetStaticProps} from 'next';

import {RENDER_MODES} from '@udemy/nextjs-core';

import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {getStaticAppContext} from 'src/pages/api/context.api';

import {getLayout} from '../../../../components/layout/layout';
import {AppContextData, PageProps} from '../../../../types/page-props';
import {AssertionPage} from './assertion-page';

export const getStaticProps: GetStaticProps = async ({locale, params}) => {
    locale = locale as string;
    const translations = await getCompactTranslations(locale);

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);

    const appContext: AppContextData = staticData;

    return {
        props: {
            appContext,
            assertionId: params?.assertionId,
            locale,
            pageKey: 'user_certifications_page',
            renderMode: RENDER_MODES.ISR,
            translations,
            userName: params?.userName,
        },
        revalidate: FOUR_HOURS,
    };
};

export const getStaticPaths: GetStaticPaths<{slug: string}> = async () => {
    return {
        paths: [], //indicates that no page needs be created at build time
        fallback: 'blocking', //indicates the type of fallback
    };
};

export default function AssertionPageWrapper(
    props: PageProps & {assertionId: string; userName: string},
) {
    return <AssertionPage assertionId={props.assertionId} />;
}

AssertionPageWrapper.getLayout = getLayout;
